import { StockImageDataService } from '@bingads-webui-campaign/stock-image-data-service';

export const getStockImageRepository = ({
  aid, cid, oDataConfig, // logger,
}) => {
  //
  const stockImageService = new StockImageDataService({
    cid, aid, oDataConfig, controller: 'StockImages',
  });

  const loadAssets = ({
    windowIndex, windowSize, searchText, filter, perfMarker,
  }) => {
    const customQueries = {
      appName: 'CampaignUI',
      $search: searchText,
      $skip: windowIndex * windowSize,
      $top: windowSize,
      language: 'en',
      includevertical: true,
      $query: filter, // stock filters
    };
    if (perfMarker) {
      perfMarker.willInit();
    }
    const $ret = stockImageService.getStockImages({ customQueries }).then((data) => {
      if (perfMarker) {
        perfMarker.done();
      }
      const totalItemCount = data && data['@odata.count'];
      const assets = data && data.value;
      return { assets, totalItemCount };
    });
    return $ret;
  };

  return {
    loadAssets,
  };
};
